import type { FC, ReactNode } from 'react'

import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { buttonVariants } from '@/components/ui/button'
import SectionHeading from '@/components/landing/section-heading'

import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger
} from '@/components/ui/accordion'

import { FAQS } from '@/constants/landing'

const FaqSection: FC = (): ReactNode => {
    return (
        <section id='faq' aria-labelledby='faq-title' className='bg-white py-20 sm:py-28'>
            <div className='mx-auto grid max-w-6xl gap-12 px-5 sm:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16 lg:px-8'>
                <div>
                    <SectionHeading
                        id='faq-title'
                        eyebrow="FAQ"
                        title="Questions, answered."
                        description="Can't find what you're looking for? Book a demo and ask us directly."
                    />

                    <a
                        href='#demo'
                        className={cn(buttonVariants({ variant: 'outline', size: 'pill' }), 'mt-8 bg-white')}
                    >
                        Book a demo
                        <ArrowRight className='size-4' />
                    </a>
                </div>

                <Accordion
                    hiddenUntilFound
                    defaultValue={[FAQS[0].question]}
                    className='gap-3'
                >
                    {FAQS.map(faq => (
                        <AccordionItem
                            key={faq.question}
                            value={faq.question}
                            className='rounded-2xl border border-border bg-background px-5 transition-colors data-open:bg-white data-open:shadow-[0_12px_30px_-20px_rgb(19_31_69/0.35)] sm:px-6'
                        >
                            <AccordionTrigger className='py-5 text-base font-semibold text-foreground hover:no-underline **:data-[slot=accordion-trigger-icon]:mt-0.5 **:data-[slot=accordion-trigger-icon]:size-5'>
                                {faq.question}
                            </AccordionTrigger>

                            <AccordionContent className='pb-5 pr-6 text-base leading-relaxed text-muted-foreground'>
                                <p>
                                    {faq.answer}
                                </p>
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    )
}

export default FaqSection
